<template>
  <v-row>
    <v-col cols="2">
      <div class="text-h4">
        {{ label }}:
      </div>
    </v-col>
    <v-col cols="2">
      <div>{{ value }}</div>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    props: {
      label: {
        type: String,
        required: true,
      },
      value: {
        type: String,
        required: true,
      },
    },
  }
</script>
